import { Outlet } from 'react-router-dom';
import { Header } from 'src/components/Header';
import { Footer } from 'src/components/Footer';
import { Toast } from '../Toast';

export const PageLayout = () => {
  return (
    <div className="nj-theme">
      <Header />

      <main className="nj-main">
        <Outlet />
      </main>

      <Toast />

      <Footer />
    </div>
  );
};
